import {
  DEFAULT_TRANSLATION_MOBILE,
  ITEM_DESKTOP_FULL_WIDTH,
  ITEM_MOBILE_FULL_WIDTH,
} from './constants';

export interface GetTranslationProps {
  toIndex: number;
  isMobile: boolean;
}

export function getTranslationInPx({
  toIndex,
  isMobile,
}: GetTranslationProps): number {
  // mobile
  if (isMobile && toIndex === 1) {
    return 0;
  }
  if (isMobile && toIndex < 1) {
    return ITEM_MOBILE_FULL_WIDTH * (-toIndex + 1) + DEFAULT_TRANSLATION_MOBILE;
  }
  if (isMobile && toIndex > 1) {
    return (
      -(ITEM_MOBILE_FULL_WIDTH * (toIndex - 1)) + DEFAULT_TRANSLATION_MOBILE
    );
  }
  // desktop
  if (!isMobile && toIndex === 2) {
    return 0;
  }
  if (!isMobile && toIndex < 2) {
    return ITEM_DESKTOP_FULL_WIDTH * (-toIndex + 2);
  }
  if (!isMobile && toIndex > 2) {
    return -(ITEM_DESKTOP_FULL_WIDTH * (toIndex - 2));
  }
  return 0;
}
